import { Box, Chip, Typography } from '@mui/material';
import { SyncAlt } from '@mui/icons-material';
import React from 'react';
import PcsCard from './PcsCard';

const BlockCard = ({
  id,
  data,
}) => {
  const name = data?.block_name || `Block ${id.toUpperCase()}`;
  const units = Object.entries(data?.pcs_data || {});

  return (
    <Box sx={{
      width: "100%",
      boxSizing: "border-box",
      backgroundColor: "var(--c-surface)",
      border: "1px solid var(--c-border)",
      borderRadius: "16px",
      overflow: "hidden",
    }}>
      {/* Header */}
      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2.5,
        py: 2,
        borderBottom: "1px solid var(--c-muted)",
      }}>
        <Box sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "var(--c-accent-bg)",
          color: "var(--c-brand)",
        }}>
          <SyncAlt fontSize="small" />
        </Box>
        <Typography sx={{ flex: 1, fontSize: 15, fontWeight: 600, color: "var(--c-text)" }} noWrap>
          {name}
        </Typography>
        <Chip
          label={`${units.length} PCS unit${units.length === 1 ? "" : "s"}`}
          size="small"
          sx={{ height: 22, fontSize: 12, fontWeight: 500, backgroundColor: "var(--c-muted)", color: "var(--c-text-3)" }}
        />
      </Box>

      {/* PCS units */}
      {units.map(([pcsId, pcsData], index) => (
        <Box key={pcsId} sx={{ borderTop: index > 0 ? "1px solid var(--c-border)" : "none" }}>
          <PcsCard
            id={pcsId}
            label={`PCS ${index + 1}`}
            data={pcsData}
          />
        </Box>
      ))}
    </Box>
  )
}

export default BlockCard;
